import Tooltip, { TooltipVariant } from 'components/Tooltip';
import React, { FC } from 'react';
import { Placement } from 'react-laag';
import { GreenPlusIcon, IconMinus } from 'static';

import { StyledButton, StyledTooltipWrap } from './styled';

interface PlusButtonProps {
  width?: string;
  contained?: boolean;
  muted?: boolean;
  disabled?: boolean;
  onClick: () => void;
  position?: Placement;
  tooltipStyle?: { [key: string]: string | number };
  text?: JSX.Element | JSX.Element[] | string;
  isVisible?: boolean;
  adjustToolTipPosition?: { [key: string]: string | number };
  isMinusIcon?: boolean;
  highlighted?: boolean;
  pinTooltip?: boolean;
  tooltipVariant?: TooltipVariant;
  onTooltipClose?: () => void;
  ariaLabel?: string;
}

const PlusButton: FC<PlusButtonProps> = ({
  width = '40px',
  contained,
  muted,
  disabled,
  onClick,
  position,
  text,
  isVisible,
  tooltipStyle,
  adjustToolTipPosition,
  isMinusIcon,
  highlighted = false,
  pinTooltip = false,
  tooltipVariant = 'light',
  onTooltipClose,
  ariaLabel,
}) =>
  text ? (
    <Tooltip
      position={position}
      tooltipStyle={{ ...tooltipStyle }}
      text={text}
      isVisible={pinTooltip || isVisible}
      isHover={!pinTooltip}
      variant={tooltipVariant}
      closeTooltip={onTooltipClose}
      adjustToolTipPosition={adjustToolTipPosition}
    >
      <StyledTooltipWrap>
        <StyledButton
          type="button"
          aria-label={ariaLabel}
          onClick={onClick}
          contained={contained}
          muted={muted}
          disabled={disabled}
          width={width}
          isMinusIcon={isMinusIcon}
          $highlighted={highlighted}
        >
          {isMinusIcon ? (
            <IconMinus width={width} height={width} />
          ) : (
            <GreenPlusIcon width={width} height={width} />
          )}
        </StyledButton>
      </StyledTooltipWrap>
    </Tooltip>
  ) : (
    <StyledButton
      type="button"
      onClick={onClick}
      contained={contained}
      muted={muted}
      disabled={disabled}
      width={width}
      isMinusIcon={isMinusIcon}
    >
      {isMinusIcon ? (
        <IconMinus width={width} height={width} />
      ) : (
        <GreenPlusIcon width={width} height={width} />
      )}
    </StyledButton>
  );

export default PlusButton;
